import React from 'react';

interface IProps {
	onChange: (value: boolean) => void;
	value: boolean;
	color?: string;
	disabled?: boolean; // new prop
}

const ToggleSwitch: React.FC<IProps> = ({ onChange, value, color, disabled = false }) => {
	return (
		<div
			onClick={() => {
				if (!disabled) {
					onChange(!value);
				}
			}}
			style={{
				width: 43,
				height: 25,
				borderRadius: 30,
				background: disabled ? '#d3d3d3' : value ? color : '#84878B',
				display: 'flex',
				alignItems: 'center',
				cursor: disabled ? 'not-allowed' : 'pointer',
				transition: 'background 0.2s',
				position: 'relative',
				boxSizing: 'border-box',
				padding: 4,
				opacity: disabled ? 0.6 : 1
			}}
		>
			<div
				style={{
					width: 21,
					height: 21,
					borderRadius: '50%',
					background: '#fff',
					boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
					position: 'absolute',
					left: value ? 19 : 3,
					transition: 'left 0.2s'
				}}
			/>
		</div>
	);
};

export default ToggleSwitch;
